import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CompanyParamsService } from '../../../core/services/company-params.service';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
  valueColor = '';
  constructor(
    private companyParamsService: CompanyParamsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.valueColor = `#${this.companyParamsService.getMainColor()}`;
    if (isPlatformBrowser(this.platformId)) {
      this.setColor();
    }
  }
  setColor() {
    let box = document.getElementById('box');
    if (box) box.style.setProperty('--boxAfterBackColor', this.valueColor);
  }
}
